import { render, staticRenderFns } from "./RegisterActivator.vue?vue&type=template&id=a5343068&scoped=true&"
import script from "./RegisterActivator.vue?vue&type=script&lang=js&"
export * from "./RegisterActivator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5343068",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
